module.exports = __webpack_public_path__ + "img/wallet.a2179b35.png";